module.exports = __webpack_public_path__ + "static/media/Avenir-MediumOblique.10db54e9.ttf";